import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable, shareReplay, tap } from 'rxjs';
import { ReferenceOption } from '../models/reference.option';

@Injectable({
  providedIn: 'root'
})
export class LangService {
  private ENGLISH_ID = -1;
  private FRENCH_ID = -1;

  @Output() initiated: Observable<any>;
  onLangChange: EventEmitter<LangChangeEvent>;
  constructor(public translate: TranslateService, private http: HttpClient) {
    this.onLangChange = this.translate.onLangChange;

    this.initiated = this.http.get<ReferenceOption[]>('/api/Reference/GetOptions/language').pipe(shareReplay()).pipe(tap((langOptions) => {
      this.ENGLISH_ID = langOptions.find((o) => o.code === 'EN').id;
      this.FRENCH_ID = langOptions.find((o) => o.code === 'FR').id;
    }));
  }

  get currentLang(): string {
    return this.translate.currentLang || localStorage.getItem('language') || 'en';
  }

  set currentLang(newLang: string) {
    this.translate.use(newLang);
    localStorage.setItem('language', newLang);
  }

  get langId() {
    return this.currentLang === 'en'
      ? this.ENGLISH_ID // english id
      : this.FRENCH_ID; // french id
  }
}
